import React, { useState } from "react";
import { IoTrashBinOutline } from "react-icons/io5";
import AddToCartButton from "../../commons/AddToCartButton";
import BuyNowButton from "../../commons/BuyNowButton";
import CustomPriceDisplay from "../../commons/CustomPriceDisplay";
import CartItemLoader from "../../commons/loaders/CartItemLoader";
import useDeleteWishlistItem from "../../hooks/useDeleteWishlistItem";
import useUser from "../../hooks/useUser";
import { getColorArray } from "./../../helpers/extractors";
import CustomOutOfStockDisplay from "../../commons/CustomOutOfStockDisplay";
import BookConsultationBtn from "../../commons/BookConsultationBtn";
import { Link } from "react-router-dom";
import { useWishlist } from "../../contexts/WishlistContext";

function AccountSavedItem({
  wishlist,
  setIsError,
  setSnackBarMessage,
  setOpenSnackBar,
  addToCart,
  isLoading,
}) {
  const [isDeleting, setIsDeleting] = useState(false);

  const { user } = useUser();

  const { deleteWishListItem } = useDeleteWishlistItem();
  const { removeFromWishlist } = useWishlist()

  const product = wishlist?.Product || wishlist?.product; // Access product details
  const isBespoke = product?.Type?.Subcategory?.Category?.name === "Bespoke";

  const data = {
    ...wishlist,
    userId: user?.id,
    productId: product?.id,
    accessToken: user?.accessToken,
  };


  const handleDeleteItem = () => {
    setIsDeleting(true);

    if (user) {
      // Remove from server wishlist
      deleteWishListItem({
        userId: user?.id,
        accessToken: user?.accessToken,
        id: wishlist?.id,
      })
        .then(() => {
          setOpenSnackBar(true);
          setSnackBarMessage("Successfully deleted");
          setIsError(false);
        })
        .catch((err) => {
          setOpenSnackBar(true);
          setSnackBarMessage(err?.message);
          setIsError(true);
        })
        .finally(() => {
          setIsDeleting(false);
        });
    } else {
      removeFromWishlist(product?.id);
      setOpenSnackBar(true);
      setSnackBarMessage("Successfully removed from wishlist");
      setIsError(false);
    }
  };

  return (
    <>
      {!isDeleting && (
        <div className="flex md:flex-row flex-col justify-between mb-8">
          <div className="flex gap-3 w-[70%]">
            <Link to={`/products/${product?.slug}`} className="font-[600] text-[18px] max-lg:text-[15px] max-md:text-[12px]">
              <div className="h-[120px] w-[120px] max-md:w-[60px] max-md:h-[60px]">
                <img
                  className="w-full h-full rounded-lg"
                  style={{ objectFit: "cover" }}
                  src={product?.imageOne}
                  alt=""
                  loading="lazy"
                />
              </div>
            </Link>
            <div className="flex flex-col gap-2">
              <Link to={`/products/${product?.slug}`} className="font-[600] text-[18px] max-lg:text-[15px] max-md:text-[12px]">
                {product?.name}
              </Link>
              {/* <p className="font-[400] text-[14px] max-lg:text-[12px] max-md:text-[10px] text-[#475367]">
                {wishlist?.Product?.colors && (
                  <div>
                    Color:{" "}
                    <span className="font-[500]">
                      {wishlist?.color?.toUpperCase()}
                    </span>
                  </div>
                )}
              </p> */}
            </div>
          </div>

          <div className="flex md:w-[60%] w-full md:justify-end">
            <div className="flex flex-col gap-2 text-right pr-10 max-md:pr-4 w-full">
              <div className="flex md:flex-col md:justify-end justify-between w-full gap-2">
                <p className="font-[600] text-[18px] max-lg:text-[15px] max-md:text-[12px]">
                  <CustomPriceDisplay
                    text={"Amount: "}
                    price={
                      product ? product?.priceAfterDiscount : 0
                    }
                  />{" "}
                </p>
                <p className="font-[500] text-[14px] max-lg:text-[12px] max-md:text-[10px]">
                  <CustomPriceDisplay
                    text={"Installation fee: "}
                    price={product?.installationPrice ?? 0}
                  />
                </p>
              </div>
              <div className="flex gap-3 md:justify-end flex-wrap">
                {isBespoke ? (
                  <BookConsultationBtn product={product} />
                ) : product?.quantity < 1 ? (
                  <CustomOutOfStockDisplay
                    quantity={product?.quantity}
                  />
                ) : (
                  <div className="flex gap-3 items-center md:justify-end flex-1">
                    <AddToCartButton
                      color={getColorArray(product?.colors)?.length === 1 ? getColorArray(product?.colors)?.[0] : wishlist?.color}
                      quantity={1}
                      productId={product?.id}
                      chooseColor={product?.colors}
                      maxSize
                      needsInstallation={product?.needsInstallation}
                    />
                    <BuyNowButton
                      color={getColorArray(product?.colors)?.length === 1 ? getColorArray(product?.colors)?.[0] : wishlist?.color}
                      quantity={wishlist?.quantity ?? 1}
                      productId={product?.id}
                      chooseColor={product?.colors}
                      slug={product?.slug}
                      maxSize
                      needsInstallation={product?.needsInstallation}
                    />
                    <div className=" w-[4%] md:hidden h-fit" onClick={handleDeleteItem}>
                      <IoTrashBinOutline className="text-[20px] max-lg:text-[16px] max-md:text-[12px] cursor-pointer text-red-600" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex-col md:flex w-[4%] hidden" onClick={handleDeleteItem}>
            <IoTrashBinOutline className="text-[20px] max-lg:text-[16px] max-md:text-[12px] mt-10 cursor-pointer text-red-600" />
          </div>
        </div>
      )}
      {isDeleting && <CartItemLoader />}
    </>
  );
}

export default AccountSavedItem;
